const Wrapper = require('./Wrapper');

class SelectricWrapper extends Wrapper {
    constructor(element) {
        super();

        this.$element = window.$(element);

        this.model = {
            value: 0
        };

        this.initEvents();
    }

    isValid() {
        return !this.required || Boolean(this.model.value);
    }

    validate() {
        if(this.isValid()) {
            this.element.classList.remove('invalid');
        } else {
            this.element.classList.add('invalid');
            if(this.element.scrollIntoView) this.element.scrollIntoView();
        }
    }

    updateUI() {

    }

    updateOptionValue(option, to) {
        let optionElement = this.$element.find('option').get(option);

        optionElement.innerHTML = optionElement.getAttribute(`data-${to}-label`); // to = [primary, secondary]

        this.$element.selectric({
            optionsItemBuilder: function(itemData, element, index) {
                return itemData.className.length ? '<svg class="select-icon' + (itemData.className == 'icon-icon-send' ? ' select-icon-red' : '') + '"><use xlink:href="#' + itemData.className.substr(5) +  '"></use></svg>' + itemData.text : itemData.text;
            }
        });
    }

    hide() {
        this.$element.selectric('destroy');
        this.$element.hide();
    }

    show() {
        this.$element.selectric({
            optionsItemBuilder: function(itemData, element, index) {
                return itemData.className.length ? '<svg class="select-icon' + (itemData.className == 'icon-icon-send' ? ' select-icon-red' : '') + '"><use xlink:href="#' + itemData.className.substr(5) +  '"></use></svg>' + itemData.text : itemData.text;
            }
        });
        this.$element.show();
    }

    initEvents() {
        this.$element.on('change', e => {
            this.updateModel({ value: e.target.value })
        });
    }
}

module.exports = SelectricWrapper;